import PropTypes from 'prop-types';

import { getContent } from '@/utils/helper';

import Text from '@/atoms/Text/Text';
import RichText from '@/molecules/RichText/RichText';
import Ingredient from '@/molecules/Ingredient/Ingredient';

import { TEXT_BASE_CLASS } from '@/atoms/Text/Text.constants';

export default function DDIngredientSection({ fields, entries }) {
  const ingredientLength = fields?.ingredients?.length;
  return (
    <div
      className="aaco__ingredient-section container mx-auto print:md:max-w-full lg:max-w-full print:md:px-0 lg:px-0 print:md:mx-0 lg:mx-0 bg-none flex flex-col"
      id="ingredients"
    >
      {ingredientLength > 0 &&
        fields.ingredients.map((i) => {
          const { content, hideTitle, title } =
            getContent(i?.sys?.id, entries)?.fields ?? {};

          if (!content?.content?.length) return;

          return (
            <div className="grid grid-cols-auto gap-y-1" key={i?.sys?.id}>
              {title && !hideTitle && (
                <Text tag="small" style="text-actual-dd-gold pt-3 first:pt-0">
                  {title}
                </Text>
              )}
              {content.content.map(
                ({ content: ingredientContent, nodeType }, idx) => {
                  return (
                    <RichText
                      entries={entries}
                      content={ingredientContent}
                      key={idx}
                      nodeType={nodeType}
                      richTextStyle={{
                        paragraph: {
                          customFont:
                            TEXT_BASE_CLASS['small'] +
                            ' dd-en:text-body-text-grey dd-kr:text-body-text-grey',
                          paragraphWrapper: 'leading-5',
                        },
                        list: {
                          paragraph: {
                            customFont:
                              TEXT_BASE_CLASS['small'] +
                              ' dd-en:body-text-grey dd-kr:body-text-grey',
                            paragraphWrapper: 'leading-5',
                          },
                          ul: 'marker:dd-kr:marker:text-body-text-grey marker:dd-en:marker:text-body-text-grey dd-kr:text-body-text-grey dd-en:text-body-text-grey pl-5',
                        },
                      }}
                    />
                  );
                }
              )}
            </div>
          );
        })}
      <Ingredient />
    </div>
  );
}

DDIngredientSection.defaultProps = {
  ingredients: [],
  title: '',
};

DDIngredientSection.propTypes = {
  fields: PropTypes.shape({
    ingredients: PropTypes.array,
    title: PropTypes.string,
  }),
};
